import React, { useState, CSSProperties, memo, useCallback, useEffect, useMemo } from "react";
import { FaEdit, FaEye, FaPlus} from "react-icons/fa";
import { Btn } from "../../../AbstractElements";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import MultiSelectDropdown from "../../../Component/BasicComponents/Dropdowns/MultiSelectDropdown";
import { useGetHolidays, useAddHoliday, useUpdateHoliday, useGetStateList } from "./hooks/useHoliday";
import { RiPencilFill } from "react-icons/ri";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { Prev } from "react-bootstrap/lib/Pagination";


type props = {};

interface TableButtonProps {
  onClick: () => void;
  title?: string;
  style?: CSSProperties;
}

type HolidayApiResponse = {
  HolidayId: number;
  Sstatename?: string;
  HolidayName: string;
  HolidayDate: string;
  Istateid: number;
  CreatedAt: string;
  UpdatedAt: string;
  CompanyId: number;
  GeoState?: {
    // Define GeoState as an optional object
    Istateid: number;
    Sstatename: string;
    Sstatecode: string;
    Dcreateddate?: string | null;
    Dmodifydate?: string | null;
  };
};

const TableButton: React.FC<TableButtonProps> = memo(
  ({ onClick, title = "Add Heads", style }) => {
    const defaultStyle: CSSProperties = {
      display: "flex",
      borderRadius: "20px",
      padding: "2px",
      width: "110px",
      height: "40px",
      justifyContent: "center",
      textAlign: "center",
      alignItems: "center",
    };

    return (
      <div>
        <button
          onClick={onClick}
          className="btn btn-info"
          style={{ ...defaultStyle, ...style }} // External styles override default
        >
          <FaPlus /> <span style={{ marginLeft: "5px" }}>{title}</span>
        </button>
      </div>
    );
  }
);

const HolidayConfiguration = (props: props) => {
  const [isModal, setIsModal] = useState(false);
  const [selectedHolidayState, setSelectedHolidayState] = useState<
    { id: number; name: string }[]
  >([]);
  const [vissibleSaveButton, setVisibleSaveButton] = useState<boolean>(true);
  const [holidayName, setHolidayName] = useState<string>("");
  const [holidayDate, setHolidayDate] = useState("");
  
  const [HolidayId,setHolidayId] = useState<number|null>(null);
  const [Istateid,setIstateid] = useState<number|null>(null);
  const [filterData,setFilterData] = useState<any>({
    page:1,
    limit:10,
    stateId:null
  })
  const [inputSerach,setInputSerach] =  useState<string>('');
  
  const HolidayColumns = [
    {
      name: "Sr.",
      selector: (row: { Sr: number }) => row.Sr,
      width: "10%",
    },
    {
      name: "Holiday Name",
      selector: (row: { HolidayName: string }) => row.HolidayName,
      width: "30%",
    },
    {
      name: "Holiday Date",
      selector: (row: { HolidayDate: string }) => row.HolidayDate,
    },
    {
      name: "State",
      selector: (row: { State: string }) => row.State,
    },
    {
      name: "Created on",
      selector: (row: { CreatedOn: string }) => row.CreatedOn,
    },

    {
      name: "Action",
      width: "120px",
      cell: (row: any) => (
        <div className="d-flex align-items-center">
          <button
            onClick={() => handleCategoryView(row)}
            className="btn btn-primary d-flex align-items-center justify-content-center"
            style={{ borderRadius: "20px", padding: "3px", width: "80px" }}
          >
            <FaEdit size={18} style={{ fill: "#fff" }} /> Edit
          </button>
        </div>
      ),
    },
  ];
 
    const { data, isLoading, isSuccess } = useGetHolidays(
      {enable: true, 
      params:{
      id:null,
      search:inputSerach,
      page: filterData.page ,
      limit:filterData.limit,
      state:filterData.stateId
      }
    });

    const {mutate:updateHoliday}  = useUpdateHoliday();
    const mutation = useAddHoliday();
    const {data:stateListData,}  = useGetStateList({enable:true});

   
  const holidayData = isSuccess && Array.isArray(data?.data?.data)
    ? data.data.data.map((item: HolidayApiResponse, index: number) => ({
        Sr: index + 1,
        HolidayId:item?.HolidayId,
        Istateid:item?.Istateid,
        HolidayName: item?.HolidayName || "N/A",
        HolidayDate: item?.HolidayDate || "N/A",
        State: item?.GeoState?.Sstatename?.trim() || "N/A",
        CreatedOn: item?.CreatedAt?.split(" ")[0] || "N/A",
        checkboxFormat: [
          {
            id: item?.HolidayId,
            name: item?.GeoState?.Sstatename?.trim() || "N/A",
          },
        ],
      }))
    : [];
  
  const dataFormDropDown = isSuccess && Array.isArray(data?.data?.data)
    ? data?.data?.data?.map((item: HolidayApiResponse) => ({
        name: item?.GeoState?.Sstatename?.trim() || "N/A",
        id: item?.GeoState?.Istateid,
      }))
    : [];
  

    // console.log('stateListData?.data',stateListData?.data);
    const formatedStateList = [ ...[{id:'',label:'All'}],
     
    ...(stateListData?.data?.map((item:any)=>({
        id:item.id,
        label:item.name
      })) ?? [])

     ]
    // console.log('formatedStateList------->',formatedStateList);
 

  const handleCategoryView = (row: any) => {
    // console.log('Row---->',row);
    setHolidayId(row.HolidayId);
    setIstateid(row.Istateid);
    
    setVisibleSaveButton(false);

    setHolidayName(row.HolidayName);
    setHolidayDate(row.HolidayDate);
    setSelectedHolidayState(row.checkboxFormat);
    setIsModal(true);
  };

  const toggelModal = () => {
    setIsModal(!isModal);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  const handleAddHolday = useCallback(() => {
    setHolidayName("");
    setHolidayDate("");
    setSelectedHolidayState([]);
    setVisibleSaveButton(true);
    setIsModal(true);
  }, []);


 const handleUpdate = ()=>{
  // new code  to update Holiday
     updateHoliday({
      id: Number(HolidayId),
      Reqbody:{
        HolidayName: String(holidayName),
        HolidayDate:String(holidayDate),
        Istateid: Istateid,
      }
     })
    setIsModal(false);

 }


  const AddHolidayHandler = () => {
    const StateID = selectedHolidayState[0].id;
    const newHolidayData = {
      HolidayName: holidayName,
      HolidayDate: holidayDate,
      Istateid: StateID,
    };
    //adding new holiday
    mutation.mutate(newHolidayData);  
    setIsModal(false);


  };

  const handleClose = () => {
    setIsModal(false);
    setVisibleSaveButton(true);
    setHolidayName("");
    setHolidayDate("");
    setSelectedHolidayState([]);
  };


  const handlePagination =(pageNo:number)=>{
    setFilterData((prev:any)=>({
               ...prev,
               page:pageNo
    }))
  }

  const  handleChangeRowPerPage=(limit:any,pageNo:any)=>{
    setFilterData((prev:any)=>({
                  ...prev,
                  page:pageNo,
                  limit:limit
    }))
  }

  return (
    <div className="p-2">
      <PageHeader
        title="Holiday Configuration"
        buttons={[

          {
            label: "Add Holiday",
            onClick:handleAddHolday ,
            // color: "#43B9B2",
          },
          {
            label: "Excel",
            onClick: () => alert("Action Excel is clicked"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Action CSV is  clicked"),
            color: "#43B9B2",
          },
        ]}
      />
      <div className="row mb-0 ">

        <BasicDataTable
         Title="Holidays"
         showSpinner={isLoading}
          tableHeaderButton={true}
          columns={HolidayColumns}
          data={!isLoading ? holidayData : []}
          headerContent={
            <>
            <div style={{marginRight:10}}>
              <RoundedDropdown
                  options={formatedStateList || []}
                  onSelect={(value:any) =>setFilterData({stateId:value.id})}
                  // defaultLabel="All"
                  width="150px"
                  isShowHeading
                  DropdownHeading="State"
                  headingColor="#2e8dd3"
                />
               </div>
            </> 
          }
          paginationTotalRows={!isLoading && data?.data?.pagination?.total_records}
          onChangePage={(pageNo:number)=>{
            handlePagination(pageNo);
        }}
          onChangeRowsPerPage={(limit:any,pageNo:any)=>{
               handleChangeRowPerPage(limit,pageNo)
          }}
          search={true}
          handleSearch={(e:any)=>setInputSerach(e)}
        />
      </div>
      <RouteModal
        title={vissibleSaveButton ? "Add Holiday" : "Update Holiday"}
        isOpen={isModal}
        size="sm"
        toggle={toggelModal}
        content={
          <form onSubmit={handleSubmit}>
            <div className="col-md-12">
              <CustomInput
                placeholder="Holiday Name"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setHolidayName(e.target.value);
                }}
                value={holidayName}
                required={true}
                label="Holiday Name*"
                style={{
                  border: "1px solid #EDEDED",
                  borderRadius: "4px",
                  padding: "10px",
                  fontSize: "14px",
                  backgroundColor: "#fff",
                }}
              />
              <CustomInput
                onChange={(e) => {
                  setHolidayDate(e.target.value);
                }}
                value={holidayDate}
                required={true}
                label="Holiday Date*"
                type="date"
                style={{
                  border: "1px solid #EDEDED",
                  borderRadius: "4px",
                  padding: "10px",
                  fontSize: "14px",
                  backgroundColor: "#fff",
                }}
              />

              <label>State*</label>
              <MultiSelectDropdown
                placeHolder="Select State"
                data={stateListData?.data ?? []}
                selectedNames={selectedHolidayState}
                setSelectedNames={setSelectedHolidayState}
              />
            </div>
            {/* Buttons */}
            <div className="d-flex justify-content-start mt-3 gap-2">
              {vissibleSaveButton && (
                <Btn
                  style={{ backgroundColor: "#43B9B2", color: "white" }}
                  type="submit"
                  disabled={
                    holidayName == ""
                      ? true
                      : holidayDate == ""
                      ? true
                      : selectedHolidayState?.length <= 0
                      ? true
                      : false
                  }
                  onClick={AddHolidayHandler}
                >
                  Save
                </Btn>
              )}
                {!vissibleSaveButton &&( <Btn
                style={{
                  backgroundColor: "#43B9B2",
                  color: "#fff",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={handleUpdate}
              >
                Update
              </Btn>)
              }
              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={handleClose}
              >
                Cancel
              </Btn>
            </div>
          </form>
        }
      />
    </div>
  );
};

export default HolidayConfiguration;
